import addDays from 'date-fns/addDays';
import isBefore from 'date-fns/isBefore';
import setDate from 'date-fns/setDate';
import subDays from 'date-fns/subDays';

/*
    CoStar's current datepicker implementation shows:
        - UPTO 7 days of "previous month"
        - UPTO 14 days of "next month"

    This function will return an array of date between
    the start and end periods, but only for days that are
    actually being rendered on screen. If a user selects
     4,000 days, this array should be at MAX:
         31 (current month) + 7 (prev month) + 14 (next month)
*/
var ONE_DAY_MICROSECONDS = 1000 * 60 * 60 * 24;
var MAX_DAYS_IN_MONTH = 31;
var PREV_MONTH_MAX_VISIBLE_DAYS = 7;
var NEXT_MONTH_MAX_VISIBLE_DAYS = 14;
var dayHighlightingHelper = function dayHighlightingHelper(_ref) {
  var visibleCalendarDate = _ref.visibleCalendarDate,
    range = _ref.range,
    selectedRange = _ref.selectedRange,
    focusedInput = _ref.focusedInput;
  var start;
  var end;
  if (selectedRange && selectedRange.min && selectedRange.max) {
    start = selectedRange.min;
    end = selectedRange.max;
  } else if (selectedRange.min && !selectedRange.max) {
    //min only
    start = selectedRange.min;
    end = range.max;
  } else if (!selectedRange.min && selectedRange.max) {
    //max only
    start = range.min;
    end = selectedRange.max;
  }
  if (start && end && start.getTime() > end.getTime()) {
    var swap = end;
    end = start;
    start = swap;
  }
  if (end && start) {
    var _selectedRange$min, _selectedRange$max;
    //-1 sets date to last-day-of-previous-month
    var last7DaysOfPrevMonth = subDays(new Date(new Date(visibleCalendarDate).setDate(-1)), PREV_MONTH_MAX_VISIBLE_DAYS);
    var first14DaysOfNextMonth = addDays(new Date(new Date(visibleCalendarDate).setDate(32)),
    //32 pushes to next month
    NEXT_MONTH_MAX_VISIBLE_DAYS);

    //if start is more than a month before the currently-visible month, then just highlight the rendered days, oterhwise use actual start date
    var visibleStart = start.getTime() < subDays(visibleCalendarDate, MAX_DAYS_IN_MONTH).getTime() ? last7DaysOfPrevMonth : start; //last 7 days of PREV MONTH

    //if end is more than a 1.5 months into the future, then just highlight some of the days, otherwise use end-date
    //
    // 1.5 months = 31 days of current month + 14 day-preview of next month
    var visibleEnd = (end.getTime() - visibleCalendarDate.getTime()) / ONE_DAY_MICROSECONDS > MAX_DAYS_IN_MONTH + NEXT_MONTH_MAX_VISIBLE_DAYS ? isBefore(first14DaysOfNextMonth, end) ? first14DaysOfNextMonth : end : end; //not right...

    var days = Math.floor((visibleEnd.getTime() - visibleStart.getTime()) / ONE_DAY_MICROSECONDS) + 1 || 0;
    var highlights = [];
    var startD = new Date(visibleStart); //utc safe here!

    for (var index = 0; index < days; index++) {
      highlights.push(addDays(startD, index));
    }
    return highlights.length ? highlights : [setDate(visibleCalendarDate, (focusedInput === 'start' ? selectedRange === null || selectedRange === void 0 ? void 0 : (_selectedRange$min = selectedRange.min) === null || _selectedRange$min === void 0 ? void 0 : _selectedRange$min.getDate() : selectedRange === null || selectedRange === void 0 ? void 0 : (_selectedRange$max = selectedRange.max) === null || _selectedRange$max === void 0 ? void 0 : _selectedRange$max.getDate()) || new Date().getDate() //use today's date
    )];
  }

  return [new Date()]; //default highlight today
};

export { dayHighlightingHelper };
//# sourceMappingURL=highlight-dates.esm.js.map
